import React from 'react'
import './about-header.css'

export default function AboutHeader() {
    return (
        <header className='about-header'>
            <h3>I'm Adrian Navarrete</h3>
            <p>
                I’m a software engineer who believes great software isn’t just functional, but it should be intuitive, impactful, and enjoyable to use.
                Clean, readable code is a top priority in my work, ensuring that anyone can pick it up and understand its purpose.
                I love exploring new programming languages and working on diverse projects to gain fresh perspectives across industries and users.
                Whether I’m building something beautiful, streamlining user experiences, or solving real-world problems,
                I stay hands-on with personal projects to keep learning and improving. My process involves structured planning with flexibility for
                creativity because the best ideas often emerge along the way.
            </p>
        </header>
    )
}